import { Routes } from '@angular/router';

// dashboard
import { AppLayout } from './layouts/app-layout';
import { AuthLayout } from './layouts/auth-layout';

export const routes: Routes = [
    {
        path: '',
        component: AppLayout,
        loadChildren: () => import('./pages/pages.route').then(m => m.PageRouting)
    },
    {
        path: 'auth',
        component: AuthLayout,
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
    },
];
